export default {"src":"/_next/static/media/spinner-trophy.c8745225.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};